import {normalizeSearchText} from './song-search-text';
import {buildSearchGroups} from './song-search-model';

// Hosanna: catalog/favorites/analytics (ADR-049). Full lyrics replace its 19-word key.
export const canonicalSongIdentity = song => JSON.stringify([
  normalizeSearchText(song.identityTitle ?? song.title), normalizeSearchText(song.lyrics)
]);

export const buildSongLibraryCatalog = documents => buildSearchGroups(documents).map(group => ({
    id: group.variants[0].songKey, title: group.variants[0].title,
    lyrics: group.variants[0].lyrics, variants: group.variants,
    keys: [...new Set(group.variants.map(variant => variant.songKey))]
  }));

export const buildSongLibrary = (documents, state, catalog = buildSongLibraryCatalog(documents)) => {
  const entries = catalog.slice();
  const known = new Set(entries.flatMap(entry => entry.keys));
  // Keep records when the last source was deleted; never reopen its obsolete position.
  [...state.favorites, ...state.usage].forEach(record => {
    if (!known.has(record.songKey)) {
      entries.push({id: record.songKey, title: record.title, lyrics: '', variants: [], keys: [record.songKey]});
      known.add(record.songKey);
    }
  });
  const favoriteKeys = new Set(state.favorites.map(record => record.songKey));
  const usageByKey = new Map();
  state.usage.forEach(record => {
    if (!usageByKey.has(record.songKey)) usageByKey.set(record.songKey, []);
    usageByKey.get(record.songKey).push(record);
  });
  return entries.map(entry => {
    const usage = entry.keys.flatMap(key => usageByKey.get(key) || []);
    const latest = usage.slice().sort((a, b) => b.lastAt.localeCompare(a.lastAt))[0];
    return {...entry, favorite: entry.keys.some(key => favoriteKeys.has(key)),
      count: usage.reduce((sum, record) => sum + record.count, 0), lastAt: latest?.lastAt,
      lastSource: latest?.source, days: new Set(usage.map(record => record.day)).size};
  }).sort((a, b) => a.title.localeCompare(b.title, 'pl') || a.id.localeCompare(b.id));
};
